
import { useRef } from 'react';

export const useSoundEffect = (soundFile = `/notification_sound.wav`) => {


  const audioRef = useRef<HTMLAudioElement | null>(null);



  if (!audioRef.current && typeof Audio !== 'undefined') {
    audioRef.current = new Audio(soundFile);
  }

  const play = (volume?: number) => {
    if (audioRef.current) {
      if (volume !== undefined) {
        audioRef.current.volume = volume * 0.01;
      }
      audioRef.current.currentTime = 0;
      audioRef.current.autoplay = true;
      audioRef.current.play().catch(error => {
        console.warn('Sound playback failed:', error);
      });
    }
  };

  return play;
};
